type ImageDimensions = {
  width: number;
  height: number;
};

export const getImageDimensionsFromUrl = (imageUrl: string): Promise<ImageDimensions> =>
  new Promise((resolve, reject) => {
    const img = new Image();

    img.onload = () => {
      resolve({
        width: img.naturalWidth,
        height: img.naturalHeight,
      });
    };

    img.onerror = () => {
      reject(new Error('Failed to load image from URL'));
    };

    img.src = imageUrl;
  });
